<template>
  <power-wrapper :CurrRole="CurrRole">
    <div class="distributorList">
      <div class="topLeft">
        <h3>店铺订单</h3>
      </div>
      <el-form :inline="true" :model="listQuery" label-width="100px">
        <el-form-item label="用户Id">
          <el-input v-model="listQuery.userId" placeholder="请输入" class="orderStyle" />
        </el-form-item>
        <el-form-item label="用户手机号">
          <el-input v-model="listQuery.phone" placeholder="请输入" class="orderStyle" />
        </el-form-item>
        <el-form-item label="子渠道Id">
          <el-input v-model="listQuery.channelId" placeholder="请输入" class="orderStyle" />
        </el-form-item>
        <el-form-item label="子渠道名称">
          <el-input v-model="listQuery.channelName" placeholder="请输入" class="orderStyle" />
        </el-form-item>
        <el-form-item label="三方平台">
          <el-select v-model="listQuery.platform" filterable placeholder="请选择三方平台">
            <el-option label="全部" value='' />
            <el-option v-for="item in platforms" :key="item.code" :label="item.name" :value='item.code' />
          </el-select>
        </el-form-item>
        <el-form-item label="三方订单号">
          <el-input v-model="listQuery.thirdOrderNumber" placeholder="请输入" class="orderStyle" />
        </el-form-item>
        <el-form-item label="达人ID">
          <el-input v-model="listQuery.authorId" placeholder="请输入" class="orderStyle" />
        </el-form-item>
        <el-form-item label="达人名称">
          <el-input v-model="listQuery.authorName" placeholder="请输入" class="orderStyle" />
        </el-form-item>
        <el-form-item label="订单创建时间">
          <el-date-picker
            v-model="createTime"
            value-format="timestamp"
            type="daterange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width:235px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="订单创建结果">
          <el-select v-model="listQuery.orderStatus" filterable placeholder="请选择订单创建结果">
            <el-option label="全部" value='' />
            <el-option label="成功" value="成功" />
            <el-option label="失败" value="失败" />
          </el-select>
        </el-form-item>
        <el-button class="filter-item" type="primary" @click="handleSearch">查询</el-button>
      </el-form>
      <el-table v-loading="listLoading" :data="list" :empty-text="emptyText" border fit highlight-current-row style="width: 100%" :header-cell-style="tableHeader">
        <el-table-column label="用户Id" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.userId || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单号" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.orderNumber || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="子渠道Id" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.channelId || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="子渠道名称" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.channelName || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品包Id" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.pkgId && row.pkgName ? `${row.pkgId}-${row.pkgName}` : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="三方平台" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ getPlatformTxt(row.platform) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="店铺名称" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.shopName || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="达人名称" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.authorName || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="达人ID" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.authorId || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="三方订单号" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.thirdOrderNumber || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单创建时间" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.ctime ? timestampToDate(row.ctime) : '--'  }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单创建结果" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.orderStatus || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单失败原因" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.failReason || '--' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="listQuery.pageNum"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>
  </power-wrapper>
</template>

<script>
import { mapGetters } from 'vuex'
import Pagination from "@/components/Pagination/index";
import PowerWrapper from "@/components/PowerWrapper";
import { getThirdOrder, getThirdPlatforms } from "@/services/order";
import { optionTrim, timestampToDateTotal } from "@/utils/utils";

export default {
  name: "order",
  components: {
    Pagination,
    PowerWrapper,
  },
  data() {
    return {
      CurrRole: "order",
      emptyText: '暂无数据',
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        linkCode: '',
        agentCode: ''
      },
      list: [],
      platforms: [],
      createTime: [new Date().getTime() - 3600 * 1000 * 24 * 7, new Date().getTime()],
      pickerMinDate: "", // 第一次选中的时间
      pickerOptions: {
        shortcuts: [
          {
            text: "今日",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨日",
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() - 24 * 60 * 60 * 1000);
              start.setHours(0, 0, 0, 0);
              const end = new Date();
              end.setTime(end.getTime() - 24 * 60 * 60 * 1000);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const end = new Date();
              const week = end.getDay();
              const millisecond = 1000 * 60 * 60 * 24;
              const minusDay = week !== 0 ? week - 1 : 6;
              const monday = new Date(end.getTime() - minusDay * millisecond);
              const start = new Date(monday);
              start.setHours(0, 0, 0, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              // 上周开始时间
              const starta = new Date();
              var first = starta.getDate() - starta.getDay() - 6;
              var startDate = new Date(starta.setDate(first));
              const start = new Date(startDate);
              start.setHours(0, 0, 0, 0);
              //  上周结束时间
              var currentDate = new Date();
              var firsts = currentDate.getDate() - currentDate.getDay() - 6;
              var last = firsts + 6;
              var endDate = new Date(currentDate.setDate(last));
              const end = new Date(endDate);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              const currentDate = new Date();
              const currentMonth = currentDate.getMonth();
              const currentYear = currentDate.getFullYear();
              const start = new Date(currentYear, currentMonth, 1);
              const end = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              const m = start.getMonth() - 1;
              start.setDate(1);
              start.setMonth(m);
              end.setDate(0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick: obj => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
        },
      },
      total: 1,
      allOrderStatu: [
        {
          value: null,
          name: '全部支付状态'
        },
        {
          value: 'PAID',
          name: '已支付'
        },
        {
          value: 'UNPAID',
          name: '未支付'
        },
        {
          value: 'REFUND',
          name: '已退费'
        }
      ],
    };
  },
  computed: {
    ...mapGetters([
    ]),
    tableHeader() {
      return () => {
        return { 'background-color': '#f5f5f5' }
      }
    }
  },
  created() {
    this.getThirdPlatforms();
    this.getList()
  },
  mounted() {
  },
  methods: {
    timestampToDate: t => timestampToDateTotal(t),
    getPlatformTxt(platform) {
      const list = this.platforms.concat([
        { code: "DirectImport", name: "表单导入" }
      ])
      const platformItem = list.find(item => item.code === platform);
      return platformItem?.name || '--';
    },
    async getThirdPlatforms() {
      try {
        const res = await getThirdPlatforms();
        const { errCode, errMsg, data } = res.data;
        if (errCode === 0) {
          this.platforms = data;
        } else {
          this.$message({ type: 'error', message: errMsg })
        }
      } catch (error) {
        this.$message({ type: 'error', message: '三方平台获取失败！请稍后重试' })
      }
    },
    async getList() {
      this.listLoading = true;
      const { listQuery, createTime } = this;
      const [ctimeBegin, ctimeEnd] = createTime || [];
      Object.assign(listQuery, {
        ctimeBegin: new Date(ctimeBegin).setHours(0, 0, 0, 0),
        ctimeEnd: new Date(ctimeEnd).setHours(23, 59, 59, 0)
      });
      const orders = await getThirdOrder({
        type: 'POST',
        params: optionTrim(listQuery)
      });
      const {
        errCode,
        errMsg,
        data,
      } = orders.data;
      const { list, total } = data || {};
      console.log(' data ', data)
      if (errCode === 0) {
        Object.assign(this, {
          list,
          total
        });
      } else {
        if (errMsg) this.$message({ type: 'error', message: errMsg });
        Object.assign(this, {
          list: [],
          total: 0
        });
      }
      this.listLoading = false;
    },
    handleSearch() {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = 10;
      this.getList();
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../styles/common.less';
.icon-question{
  cursor: pointer;
}
</style>
